import { RouteRecordRaw } from 'vue-router'

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/login',
    name: 'login',
    component: () => import('@/modules/account/pages/Login.vue'),
    meta: {
      requiresAuth: false,
      pageTitle: 'Login',
      header: false,
    },
  },
  {
    path: '/venue/reset-password',
    name: 'resetPassword',
    component: () => import('@/modules/account/pages/ResetPassword.vue'),
    meta: {
      requiresAuth: false,
      pageTitle: 'Reset Password',
      header: false,
    },
  },
  {
    path: '/venue/set-password',
    name: 'setPassword',
    component: () => import('@/modules/account/pages/SetPassword.vue'),
    meta: {
      requiresAuth: false,
      pageTitle: 'Set Password',
      header: false,
    },
  },
]
